export enum StyleTypes {
  danger = 'DANGER',
  filled = 'FILLED',
  link = 'LINK',
  outlined = 'OUTLINED',
  success = 'SUCCESS',
  update = 'UPDATE',
  update_violet = 'UPDATE VIOLET',
  simple = 'SIMPLE',
  simpleDanger = 'SIMPLE_DANGER',
  successOutlined = 'SUCCESS_OUTLINED',
}
